import React from 'react';
import { Image } from 'react-bootstrap';
import Style from './Header.module.css';
import { useBranding } from '../context/BrandingContext';
import defaultLogo from '../assets/img/Logo.jpg';

const Header = () => {
    const { logoUrl } = useBranding();
    const logoSrc = logoUrl || defaultLogo;

    return ( 
        <header className={Style.header_row}>
            <div className={Style.header_row_content}>
                <div className={Style.header_row_icon}>
                    <Image className={Style.icon} src={logoSrc} alt="" onError={(e) => { e.target.src = defaultLogo; }} />
                </div>
            </div>
        </header>
     );
}
 
export default Header;
